import getCombatantIndexById from './getCombatantIndexById'
import store from '../store/index'
import blankReaction from '../assets/images/bbBlankAction.png'
//----------------
// set blank slot
//----------------
export default function setBlankCR(parm) {
  //--------------
  // access store
  //--------------
  const this_store = store.state.combat
  let combatants = this_store.arena.arena_combatants
  //------------------
  // get combatant idx
  //------------------
  let i = getCombatantIndexById(parm.id)
  //------------------
  // set var cr props
  //------------------
  let cr = 'cr' + parm.cr_num
  let cr_name = 'cr_name' + parm.cr_num
  let cr_slug = 'cr_slug' + parm.cr_num
  //----------------
  // set blank slot
  //----------------
  combatants[i][cr] = blankReaction
  combatants[i][cr_name] = 'blank'
  combatants[i][cr_slug] = ''
}
